import styled from "styled-components";

const Button = styled.button<{ color: string; bgColor: string; }>`
background-color:  ${props => props.bgColor};
padding: 10px 15px;
margin-top: 20px;
border-radius: 10px;
cursor: pointer; 
font-size: 1em;
color: ${props => props.color};
border: 2px solid ${props => props.color};
  &:hover {
    opacity: 0.8
  } 
`;

export default Button;
